import Logo from '../components/Logo.js';
import NavBar from '../components/NavBar.js';
import Footer from '../components/Footer.js';

import React from 'react';
import styled from 'styled-components';

const Page = styled.div`
position:relative;
min-height:70vh;
overflow-y: scroll;
padding-bottom:300px;
`
const Title = styled.h2`
margin:0 auto;
margin: 20px;
`

const Accueil = () => {
    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Title>IGLS Data</Title>
            <p>Site de gestion des données des IGLS</p>
            <Footer/>
        </Page>
    )
}
export default Accueil